interface EntityScopedTemplate {
    id: string;
    entityIds: number[];
}

interface ResolvePickerTemplatesOptions<
    TTemplate extends EntityScopedTemplate,
> {
    templates: TTemplate[] | undefined;
    /** Row's entity — templates are scoped per entity via their account rows. */
    entityId: number | undefined;
    /**
     * Deep-linked or just-created template to float to the top, so arriving
     * from "Apply <schedule>" does not mean hunting for it in the list.
     */
    prioritizedTemplateId?: string;
    /**
     * The prioritized template itself, for when it is not in `templates` yet —
     * e.g. created moments ago and the cached list has not refetched.
     */
    prioritizedTemplate?: TTemplate;
}

export function resolvePickerTemplates<TTemplate extends EntityScopedTemplate>({
    templates,
    entityId,
    prioritizedTemplateId,
    prioritizedTemplate,
}: ResolvePickerTemplatesOptions<TTemplate>): TTemplate[] {
    const all = [...(templates ?? [])];
    if (
        prioritizedTemplate &&
        !all.some((template) => template.id === prioritizedTemplate.id)
    ) {
        all.push(prioritizedTemplate);
    }
    const eligible =
        entityId == null
            ? []
            : all.filter((template) => template.entityIds.includes(entityId));

    if (!prioritizedTemplateId) {
        return eligible;
    }
    return [...eligible].sort((first, second) => {
        if (first.id === prioritizedTemplateId) {
            return -1;
        }
        if (second.id === prioritizedTemplateId) {
            return 1;
        }
        return 0;
    });
}
